/**
 * Relatedness to core — one formula everywhere (WQ-343, D1(a)).
 *
 * Weighted Bain composite: shared customers count most. The Priority Matrix
 * places bubbles with this value and the node editor shows the same number.
 */

import type { AdjacencyNode } from '../types/adjacency';

type BainScores = Pick<AdjacencyNode, 'sharedCustomers' | 'sharedCosts' | 'commonCompetitors'>;

export const RELATEDNESS_WEIGHTING_LABEL = 'Customers 40% · Costs 30% · Competitors 30%';

/** Weighted 0.4 / 0.3 / 0.3. Same arithmetic as the Matrix always used, so bubbles don't move. */
export function relatednessScore(scores: BainScores): number {
  return scores.sharedCustomers * 0.4 + scores.sharedCosts * 0.3 + scores.commonCompetitors * 0.3;
}

/** One display rounding for every place that prints the score. */
export function formatRelatedness(score: number): string {
  return score.toFixed(1);
}
